import { UiBox, UiButtonBase, UiTooltip } from "@smp/ui";
import { IconCheck } from "@tabler/icons-react";
import clsx from "clsx";

import { useStyles } from "./filter_color_button.css";

export const FilterColorButton = ({
  isActive,
  color,
  title,
  value,
  onChange,
}: {
  isActive: boolean;
  color?: string;
  title: string;
  value: string;
  onChange: (color: string) => void;
}) => {
  const classes = useStyles({ color: color || "" });

  const handleClick = () => {
    onChange(value);
  };

  return (
    <UiButtonBase
      onClick={handleClick}
      className={clsx(classes.button, {
        [classes["button--bordered"]]:
          value.includes("white") || value.includes("ffffff"),
        [classes["button--gradient"]]: value === "all",
      })}
    >
      <UiTooltip title={title} placement="top">
        <UiBox>
          <IconCheck
            className={clsx(classes.check, {
              [classes["check--active"]]: isActive,
            })}
          />
        </UiBox>
      </UiTooltip>
    </UiButtonBase>
  );
};
